import React, { useEffect } from "react";
import { FaAngleLeft } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAExam,
  getGetExamError,
  getGetExamStatus,
  getExamData,
} from "../../../redux/slice/examsSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";

import QuestionList from "../question/QuestionList";

const ViewExamFragment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = useParams().id;
  const examData = useSelector(getExamData);
  const status = useSelector(getGetExamStatus);
  const error = useSelector(getGetExamError);

  const fromDate = new Date(examData?.fromDate);
  const toDate = new Date(examData?.toDate);

  useEffect(() => {
    if (!examData) {
      dispatch(getAExam(id));
    }
  }, [dispatch, id, examData]);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <section className="flex flex-col w-full sm:gap-12 gap-6">
      {status === "loading" ? <Loading /> : null}
      {status === "error" ? <AlertBox type="error" message={error} /> : null}
      <div className="flex w-full justify-between items-center">
        <h1 className="text-[24px] font-semibold">View Exam</h1>
      </div>
      <div className="bg-primary flex flex-col gap-5 w-full sm:p-7 p-3 rounded-[8px] border-1 border-[#DFE0EB] shadow-md">
        <div className="flex sm:flex-row flex-col justify-between sm:items-center items-end w-full">
          <button
            type="button"
            onClick={handleBack}
            className="w-14 flex flex-row gap-2 items-center sm:self-center self-start"
          >
            <FaAngleLeft />
            <span>Back</span>
          </button>
          <div className="py-2 px-4 bg-adminPrimary border shadow-sm rounded-md">
            <span className="font-medium tracking-wide text-sm text-adminRightTextPrimary">
              Topic: {examData?.topicName}
            </span>
          </div>
          <div className="py-2 px-4 bg-adminPrimary border shadow-sm rounded-md">
            <span className="font-medium tracking-wide text-sm text-adminRightTextPrimary">
              From: {fromDate.toLocaleDateString()}
            </span>
          </div>
          <div className="py-2 px-4 bg-adminPrimary border shadow-sm rounded-md">
            <span className="font-medium tracking-wide text-sm text-adminRightTextPrimary">
              To: {toDate.toLocaleDateString()}
            </span>
          </div>
        </div>
        {examData && <QuestionList questions={examData.questions} />}
      </div>
    </section>
  );
};

export default ViewExamFragment;
